import { FaceLiftGlobalStyle } from "../../../styles/theme";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import DefaultDarkModeHOC from "../../../components/theme/DefaultDarkModeHOC";

import { Footer } from "../../../components/blog/footerBlog";
import { TopbarLanding } from "../../../components/LandingPage/topbar";
import {
	getI18nProps,
	getStaticPaths,
} from "../../../lib/next-i18next/getStatic";
import WhatsAppButton from "../../../components/WhatsAppButton";
import ContactSectionForm from "../../../components/ContactSectionForm";
import {
	ChallengeSection,
	HeroSection,
	SolutionSection,
	ResultsSection,
	RpaSection,
} from "./views/brinks-sections";

function ProductMetadata() {
	const { t } = useTranslation();

	return (
		<Head>
			{/* <!-- Primary Meta Tags --> */}
			<title>{t("cases.brinks.metadata.title")}</title>
			<meta name="title" content={t("cases.brinks.metadata.metaTitle")} />
			<meta
				name="description"
				content={t("cases.brinks.metadata.metaDescription")}
			/>

			{/* <!-- Open Graph / Facebook / Instagram --> */}
			<meta property="og:type" content="website" />
			<meta
				property="og:url"
				content="/casos/brinks"
			/>
			<meta
				property="og:title"
				content={t("cases.brinks.metadata.metaTitle")}
			/>
			<meta
				property="og:description"
				content={t("cases.brinks.metadata.metaDescription")}
			/>
			<meta
				property="og:image"
				content="/landings/assets/images/casos/assets/brinks/brinks-banner.png"
			/>

			{/* <!-- LinkedIn --> */}
			<meta property="twitter:card" content="summary_large_image" />
			<meta
				property="twitter:url"
				content="/casos/brinks"
			/>
			<meta
				property="twitter:title"
				content={t("cases.brinks.metadata.metaTitle")}
			/>
			<meta
				property="twitter:description"
				content={t("cases.brinks.metadata.metaDescription")}
			/>
			<meta
				property="twitter:image"
				content="/landings/assets/images/casos/assets/brinks/brinks-banner.png"
			/>
		</Head>
	);
}

export default function Brinks() {
	const { t } = useTranslation();

	return (
		<DefaultDarkModeHOC>
			<ProductMetadata />
			<TopbarLanding />
			<FaceLiftGlobalStyle />
			<WhatsAppButton />

			<main>
				<HeroSection />
				<ChallengeSection />
				<SolutionSection />
				<ResultsSection />

				<RpaSection />

				<ContactSectionForm
					title={t("products.rpa.contact.title")}
					description={t("products.rpa.contact.description")}
				/>
			</main>

			<Footer defaultTheme="dark" />
		</DefaultDarkModeHOC>
	);
}

export const getStaticProps = async (ctx) => {
	const i18nProps = await getI18nProps(ctx);

	return {
		props: {
			...i18nProps,
			locale: i18nProps._nextI18Next.initialLocale,
		},
	};
};

export { getStaticPaths };
